// CardPreviewChips — small inline chip row showing the cards a kid
// will earn from eating this dish. Used by:
//   • RecipeKidMenuSection (recipe page, recipe.ingredients[])
//   • KidRequestableSection (kitchen item card, single-row preview)
//
// Pure presentation. Caller passes a prediction object shaped
// `{ build, super, boost, spark, dairy, water }` (the return of
// cardsForRecipe / cardForKitchenItem). Empty prediction → null.

import { FONT, COLOR } from "../lib/tokens";
import { KID_CARD_TYPES } from "../experiments/kids-mode/cardTypes";
import { totalCardCount } from "../lib/cardsForRecipe";

const CARD_ORDER = ["build", "dairy", "super", "boost", "spark", "water"];
const META_BY_KEY = Object.fromEntries(KID_CARD_TYPES.map((c) => [c.key, c]));

export default function CardPreviewChips({ prediction, compact = false }) {
  if (!prediction) return null;
  const total = totalCardCount(prediction);
  if (total === 0) return null;

  return (
    <div style={{
      display: "flex", flexDirection: "column", gap: compact ? 4 : 6,
      marginTop: compact ? 6 : 10,
    }}>
      <div style={{
        fontFamily: FONT.mono,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: "0.14em",
        color: COLOR.sub,
        textTransform: "uppercase",
      }}>
        Powers up the pet
      </div>
      <div style={{
        display: "flex", flexWrap: "wrap", gap: 6,
      }}>
        {CARD_ORDER.map((key) => {
          const count = prediction[key] || 0;
          if (count <= 0) return null;
          const meta = META_BY_KEY[key];
          if (!meta) return null;
          return (
            <span
              key={key}
              title={`${count} × ${meta.label} (${meta.blurb})`}
              style={{
                display: "inline-flex", alignItems: "center", gap: 5,
                padding: "5px 9px",
                background: `${meta.tint}22`,
                border: `1px solid ${meta.tint}88`,
                borderRadius: 999,
                fontFamily: FONT.forma,
                fontSize: 12,
                fontWeight: 600,
                color: COLOR.ink,
              }}
            >
              <span style={{ fontSize: 14, lineHeight: 1 }}>{meta.emoji}</span>
              <span style={{ fontVariantNumeric: "tabular-nums" }}>
                {count}
              </span>
              <span style={{ color: meta.tint, fontWeight: 700 }}>
                {meta.label}
              </span>
            </span>
          );
        })}
      </div>
    </div>
  );
}
